/**
* Logo Grid JS
* -----------------------------------------------------------------------------
*
* All the JS for the Logo Grid component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {

    className: 'logo-grid',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.logo-grid__upper-splide' ).each( function( key, component ) {
        new Splide( component, {
          type: 'loop',
          autoWidth: true,
          autoHeight: true,
          gap: '20px',
          autoScroll: {
            speed: 0.75,
            pauseOnHover: false,
          },
          arrows: false,
          pagination: false,
          mediaQuery: 'min',
          breakpoints: {
            768: {
              destroy: true,
            },
          },
        } ).mount( {AutoScroll} );
      } );
      $( '.logo-grid__lower-splide' ).each( function( key, component ) {
        new Splide( component, {
          type: 'loop',
          autoWidth: true,
          autoHeight: true,
          gap: '20px',
          autoScroll: {
            speed: -0.75,
            pauseOnHover: false,
          },
          arrows: false,
          pagination: false,
          mediaQuery: 'min',
          breakpoints: {
            768: {
              destroy: true,
            },
          },
        } ).mount( {AutoScroll} );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'logo-grid', COMPONENT );
} )( app );
